import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MemberBankAccountDataService {

  constructor() {}

  maskAccountNumber(accountNumber: string) {
    if (!accountNumber) {
      return accountNumber;
    }

    const mask = "*".repeat(9);
    return mask + accountNumber.slice(-4);
  }
}
